/**
 * Problem equation renderer.
 */
import React, { useEffect, useState } from "react";
import MathJax from 'react-mathjax';

import { extractMathExpression } from "utils/string";
import SafeHtml from "pages/common/SafeHtml";

/**
 * Renders math from an equation OLX tag.
 *
 * @param {{ tag: Element }} props
 */
export default function EquationRender(props) {
  const { tag } = props;

  const [expressions, setExpressions] = useState([]);

  useEffect(() => setExpressions(extractMathExpression(tag.innerHTML.trim())), [tag]);

  return <div className="mt-3 mb-3">
    {
      expressions.map((ex, key) =>
        ex.isMath ?
          <span key={key}>
            <MathJax.Provider key={key}>
              <MathJax.Node formula={ex.text} />
            </MathJax.Provider>
          </span>
          :
          <SafeHtml key={key} as="span" html={ex.text} course />
      )
    }

  </div>;
}